import type { UpdateAttendanceSettingMutationVariables } from 'generated/resources/graphql'
import { UpdateAttendanceSettingDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type AttendanceMutationsUpdateAttendanceEmployeesSettingArgs =
  UpdateAttendanceSettingMutationVariables

export const useUpdateTimeTrackingSetting = () => {
  const [updateTimeTrackingSetting, { loading }] = useMutation(UpdateAttendanceSettingDocument, {
    extractorFn: (data) => data.attendanceMutations.updateAttendanceEmployeesSetting,
  })

  const updateSetting = (variables: AttendanceMutationsUpdateAttendanceEmployeesSettingArgs) => {
    return updateTimeTrackingSetting({
      variables,
    })
  }

  return {
    loading,
    updateSetting,
  }
}
